module.exports = "<div class=\"creator\">\n  <div class=\"hidden-xs\"><a routerLink=\"/home\">Capsyco© - Accompagnement au mieux-être - Tous droits réservés</a></div>\n  <div class=\"hidden-sm hidden-md hidden-lg hidden-xl\"><a href=\"/\">Capsyco© - Accompagnement au mieux-être</a></div>\n  <div><a href=\"http://www.enzotesta.xyz\"> Site réalisé par Enzo TESTA</a></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/enzo/Desktop/capsycofr-angular/src/app/components/creator/creator.component.html
// module id = ../../../../../src/app/components/creator/creator.component.html
// module chunks = main